import 'react-app-polyfill/stable';
import 'core-js/stable';
import React from "react";
import {createRoot} from "react-dom/client";
import App from './app';
import FeatureFlags from './components/FeatureFlags/FeatureFlags';
import {logErrorsToServer} from './utils/errorLogging';

import "@investec/ids-web-theme-investec/index.css";
import '@investec/ids-web-react/index.css';
import './assets/scss/global-styles.scss';

const rootElement = document.getElementById('root');

logErrorsToServer();

if (!rootElement) {
  throw new Error('Unable to find root element');
}

createRoot(rootElement).render(
  <FeatureFlags>
    <App />
  </FeatureFlags>
);
